// Centralized constants for the order management system
//
// NOTE: Order-related constants have been moved to @/constants/orderConstants.ts
// This file re-exports them for backward compatibility
import {
  ORDER_STATUS_OPTIONS,
  ORDER_SOURCE_OPTIONS,
  ORDER_CATEGORY_OPTIONS,
  ORDER_STATUS,
  ORDER_SOURCE,
  ORDER_CATEGORY,
} from "@/constants/orderConstants";

// Re-export arrays for backward compatibility
export const ORDER_STATUSES = ORDER_STATUS_OPTIONS;
export const ORDER_SOURCES = ORDER_SOURCE_OPTIONS;
export const ORDER_CATEGORIES = ORDER_CATEGORY_OPTIONS;

// Re-export individual constants
export { ORDER_STATUS, ORDER_SOURCE, ORDER_CATEGORY };

export const CURRENCY = {
  symbol: "₾",
  code: "GEL",
  name: "Georgian Lari"
} as const;

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 50,
  PAGE_SIZE_OPTIONS: [25, 50, 100, 200] as const,
  MOBILE_PAGE_SIZE: 20,
} as const;
